export default __webpack_public_path__ + "static/pic-join-our-team-b99da207ffc8f86ca40c3df59bc04a44.jpeg";